<template>
    <div class="modal" :class="{'is-active': isActive}" v-if="isActive" v-e2e="'modal-alterar-data'">
      <div class="modal-background" v-e2e="'modal-alterar-data-background'"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Alterar vencimento</p>
          <button class="delete" aria-label="fechar" title="Fechar" @click="doCancelarAlteracaoDeData" v-e2e="'modal-alterar-data-btn-fechar'"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <label for="ipt-alterar-data-processo" :class="{ 'error-label': !validations.novaData && isFormDirty }" v-e2e="'modal-alterar-data-label'">
                Nova data de expectativa de conclusão
              </label>
            </div>
            <div class="column is-6">
              <input
                id="ipt-alterar-data-processo"
                class="input"
                :class="{ 'error-label': !validations.novaData && isFormDirty }"
                type="date"
                placeholder="Insira a nova data de vencimento"
                v-model="dataValue.novaData"
                ref="input-alterar-data"
                :min="dataMinima"
                v-e2e="'input-alterar-data'"
                @change="setDataNova"
              />
              <p v-if="!validations.novaData && isFormDirty && errorMessage != ''" class="error-message mt-4">{{ errorMessage }}</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="buttons ml-auto">
            <TrfButton
              nome="Confirmar"
              :temIcon="false"
              id="btn-confirmar-alteracao-data"
              type="button"
              classCor="is-primary"
              :disabled="isLoading"
              :isBtnLoading="isLoading"
              @click="async ($event) => await doSalvarAlteracaoDeData($event)"
              v-e2e="'modal-alterar-data-btn-salvar'"
            />
            <TrfButton
              nome="Cancelar"
              :temIcon="false"
              id="btn-cancelar-alteracao-data"
              type="button"
              :disabled="isLoading"
              @click.prevent="doCancelarAlteracaoDeData"
              v-e2e="'modal-alterar-data-btn-cancelar'"
            />
          </div>
        </footer>
      </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { utils } from '../../util/utils';
import { toastUtils } from '../../util/toast.utils';

export default {
  name: 'TrfModalAlterarData',
  emits: ['trf-modal-alterar-data-closed', 'trf-modal-alterar-data-success'],
  components: {
    TrfButton: defineAsyncComponent(() => import('../Button/index.vue')),
  },
  props: {
    item: {
        type: Object,
        default: null,
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        novaData: null
      },
      dataValue: {
        novaData: ''
      },
      validations: {
        novaData: false
      },
      isFormDirty: false,
      isLoading: false,
      errorMessage: ''
    };
  },
  computed: {
    dataPrevisaoConclusao() {
      if(!this.item || !this.item.dataPrevisaoConclusao) return null;
      const dataAsDate = utils.formatarStringToDate(this.item.dataPrevisaoConclusao)
      return utils.formatarCampoDataParaEnvioAoBackendSemHora(dataAsDate);
    },
    dataMinima() {
      if(!this.item || !this.item.dataPrevisaoConclusao) return null;
      const dataAsDate = utils.formatarStringToDate(this.item.dataPrevisaoConclusao, 1)
      return utils.formatarCampoDataParaEnvioAoBackendSemHora(dataAsDate);
    },
    dataSelecionadaParaOBack() {
      if(!this.formData.novaData) return null;
      return utils.formatarCampoDataParaEnvioAoBackendSemHora(this.formData.novaData);
    },
    isFormValido() {
      const dataSelecionada = this.dataValue.novaData;
      const validarData = this.validateNovaData(dataSelecionada);
      return validarData;
    }
  },
  methods: {
    async importProcessoService() {
      const { processoService } = await import('../../service/processo-service.js');
      return processoService
    },
    setDataNova(event) {
      this.isFormDirty = true
      const targetValue = event?.target?.value;
      this.validations.novaData = this.validateNovaData(targetValue)
      if (!targetValue) return;
      if (!this.validations.novaData) return;
      this.formData.novaData = this.dataValue.novaData;
    },
    validateNovaData(valor) {
      if(!valor) {
        this.errorMessage = "Novo prazo de expectativa de conclusão inválido!"
        return false;
      }
      const newDateZeroHour = new Date(valor).setHours(0, 0, 0, 0);
      const oldDateZeroHour = new Date(this.dataPrevisaoConclusao).setHours(0, 0, 0, 0);

      if (newDateZeroHour && newDateZeroHour == oldDateZeroHour) {
        this.errorMessage = "O prazo de expectativa de conclusão informado é o mesmo prazo de expectativa de conclusão do processo, portanto não pode ser ajustado."
      }

      if (newDateZeroHour && newDateZeroHour < oldDateZeroHour) {
        this.errorMessage = "O prazo de expectativa de conclusão informado é menor que o prazo de expectativa de conclusão do processo, portanto não pode ser ajustado."
      }

      return newDateZeroHour > oldDateZeroHour;
    },
    doReset() {
      this.formData = {
        novaData: false
      }
      this.validations = {
        novaData: false
      }
      this.dataValue = {
        novaData: ''
      },
      this.isFormDirty = false;
      this.isLoading = false;
    },
    async doSalvarAlteracaoDeData() {
      try {
        this.isLoading = true;
        this.isFormDirty = true
        if(!this.isFormValido) throw new Error("Novo prazo de expectativa de conclusão inválido!")
        const processoService = await this.importProcessoService();
        await processoService.editarPrevisaoConclusao({
          id: this.item.id,
          dataPrevisaoConclusao: this.dataSelecionadaParaOBack
        })
        toastUtils.successToast("Data de expectativa de conclusão alterada com sucesso!")
        this.doCancelarAlteracaoDeData()
        this.$emit('trf-modal-alterar-data-success', true);
      } catch (e) {
        if(this.errorMessage != '') {
          console.warn(`WARN: ${e.message? e.message : e}`);
          toastUtils.dangerToast("Novo prazo de expectativa de conclusão inválido!")
        } else {
          console.error(`ERR: ${e}`);
          toastUtils.dangerToast("Não foi possível alterar a data.\nVerifique os dados e tente novamente.")
        }
        this.isLoading = false;
      }
    },
    async doCancelarAlteracaoDeData() {
      this.doReset();
      this.doFecharModal();
    },
    doFecharModal() {
      this.$emit('trf-modal-alterar-data-closed', false)
    }
  }
};
</script>
<style lang="scss" scoped>
.error-input {
  border: #a94442;
}
.error-message {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.error-label {
  color: #a94442;
}
</style>
